import { TicketingTable } from '@services/member/ticketing/ticketing.types';
import { useGetTicketTypesMutation } from '@services/member/list/list.endpoints';
import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { TicketType } from '@services/member/list/ticket-types/ticket-types.types';

export const useTicketingEditionPageVM = () => {

    const [totalMembers, setTotalMembers] = useState<number>(0);
    const [ticketTypes, setTicketTypes] = useState<TicketType[]>([]);
    const columnHelper = createColumnHelper<TicketingTable>();

    const [getTicketTypes, { isSuccess: isGetTicketTypesSuccess, isLoading: isGetTicketTypesLoading, data: ticketTypesData }] =
        useGetTicketTypesMutation();

    useEffect(() => {
        getTicketTypes(undefined);
    }, []);

    useEffect(() => {
        if (isGetTicketTypesLoading) return;
        if (isGetTicketTypesSuccess && ticketTypesData) {
            setTicketTypes(ticketTypesData.data);
        }
    }, [isGetTicketTypesSuccess]);

       const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalMembers(metadata.total);
        }
    };

    return {
        handleMetadata,
        columnHelper,
        ticketTypes,
        totalMembers
    };
};
